import React from 'react'
import styled, { css } from 'styled-components'

const StyledInput = styled.input`
  border-radius: 20px;
  border: solid 1px #e1e4e8;
  color: #0a1f44;
  font-size: 14px;
  line-height: 1.75;
  padding: 8px 12px;
  width: 100%;

  &:focus {
    font-weight: 500;

    &::placeholder {
      font-weight: initial;
    }
  }

  &::placeholder {
    color: #8a94a6;
  }

  &:disabled {
    background-color: #f7f8f9;
    cursor: 'default';

    &::placeholder {
      color: #b0b7c3;
    }
  }

  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}

  ${({ error }) =>
    error &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.red};
      color: ${({ theme }) => theme.colors.red};

      &::placeholder {
        color: ${({ theme }) => theme.colors.red};
      }
    `}
`

const StyledInputWrapper = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  position: relative;
  width: 100%;

  ${({ theme }) => theme.media.tablet} {
    :nth-child(odd) {
      margin-right: 24px;
    }
  
    :last-child {
      margin-right: 0;
    }
  }
`

const TextInput = ({
  errors,
  hidden,
  id,
  label,
  name,
  onChange,
  placeholder,
  required,
  type,
  value,
}) => {

  return (
    <StyledInputWrapper>
      <StyledInput
        autoComplete="off"
        error={errors}
        hidden={hidden}
        id={id}
        label={label}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        type={type}
        value={value}
      />
    </StyledInputWrapper>
  )
}

export default TextInput